import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    settlementList: [],
    settlementArray: [],
    date_search: '',
    selectedSettlement: null,
  };
  
  const mutations = {
    LIST_LOAN_SETTLEMENTS(state, settlements) {
      state.settlementList = settlements;
    },

    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){

      }
    },

    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    RESET_SEARCH_FILTERS(state){

    }
  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },

    fetchLoanSettlements({ commit,state }, formData) {
        axios.post(`api/v1/loan-settlements-search/`,formData)
        .then((response)=>{
            commit('LIST_LOAN_SETTLEMENTS',response.data);
        })
        .catch((error)=>{
          console.log(error.message);
        })
        
    },
    deleteLoanSettlement({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Settlement?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Settlement!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-loan-settlement/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Settlement removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Settlement",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Settlement has not been deleted!`);
        }
      })
    },

  };
  
  const getters = {

  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  